module.exports = __webpack_public_path__ + "static/media/logout.36dcac6d.svg";